import SsoView from './SsoView.vue';

export default SsoView;
